import {Injectable} from '@angular/core';

/**
 * Service generate CSV file and download it on user's device
 */
@Injectable({
  providedIn: 'root',
})
export class ExportService {
  /**
   * Function download generated CSV file
   *
   * @param data
   * @param filename
   */
  downloadFile(data: any, filename = 'data', headers?: string[]) {
    const headerList = headers ? headers : Object.keys(data[0]);
    const csvData = this.convertToCSV(data, headerList);
    const blob = new Blob(['\ufeff' + csvData], {
      type: 'text/csv;charset=utf-8;',
    });
    const dwldLink = document.createElement('a');
    const url = URL.createObjectURL(blob);
    const isSafariBrowser =
      navigator.userAgent.indexOf('Safari') != -1 &&
      navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      // if Safari open in new window to save file with random filename.
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  /**
   * Convert data into CSV file
   *
   * @param objArray data that needs to be converted
   * @param headerList array of hedears from table
   * @returns
   */
  convertToCSV(objArray: any, headerList: string[]) {
    const array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '#;';

    for (const headerListItem of headerList) {
      row += headerListItem + ';';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + '';
      for (const headerListItem0 of headerList) {
        let item = array[i][headerListItem0];
        if (item === undefined) item = '';
        line += ';' + item;
      }
      str += line + '\r\n';
    }
    return str;
  }
}
